<template>
	<!-- .stop keeps the click from reaching the Disclosure accessory wrapper (whose .prevent
	     would cancel the native toggle) and from expanding/collapsing the panel -->
	<span class="SectionToggle" @click.stop>
		<v-switch density="compact" hide-details color="primary"
			:model-value="modelValue"
			:disabled="disabled"
			@update:modelValue="$emit('toggle', !!$event)"
		/>
	</span>
</template>

<script>
export default {
	name: 'SectionToggle',
	props: {
		modelValue: Boolean,
		disabled: Boolean,
	},
	emits: [ 'toggle' ],
}
</script>

<style scoped>
.SectionToggle { display: inline-flex; }
</style>
